import React from 'react';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import { Circles } from '../../common/loadingComponent';

import '../repi.scss';

class RepiConfirmDataCorrectionPopup extends React.Component {
    static defaultProps = {
        yesButtonDisabled: false,
        noButtonDisabled: false,
        noButtonVisible: false
    };

    state = { procesing: false };

    render() {
        if (this.state.processing) {
            return (
                <div className="repi-confirm-dc-loader-container">
                    <Circles />
                </div>
            );
        }

        return (
            <>
                <div>
                    {ReactHtmlParser(this.props.htmlBody)}
                </div>
                <br />
                <div className="modal-inner-buttons">
                    <button type="button" onClick={this.onYesClicked} disabled={this.props.yesButtonDisabled}
                        className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}>{this.props.yesButtonText}
                    </button>
                    {this.props.noButtonVisible && <button type="button"
                        onClick={() => this.props.close()} disabled={this.props.noButtonDisabled}
                        className={classnames('bb-button gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })}
                    >
                        {this.props.noButtonText}
                    </button>}
                </div>
            </>
        );
    }

    onYesClicked = () =>
        this.setState({ processing: true }, () => this.props.yesButtonFunction(() => this.setState({ processing: false })));
}

export default (RepiConfirmDataCorrectionPopup);
